import { useState } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

export const Loader = () => {
    return <FontAwesomeIcon icon={faSpinner} spin />;
}

export const useGenerals = () => {
    let currDomain = window.location.hostname;
    let domainBackEnd;

    currDomain === 'localhost' ? domainBackEnd = 'http://www.westsidevillageapartments.com/backend' : domainBackEnd = 'http://www.westsidevillageapartments.com/backend' ;
    
    const [ generals ] = useState({
        domainBackEnd:domainBackEnd
    });

    return generals;
}

export const useMain = () =>{
    let currenMain = localStorage.getItem('main');
    
    if(currenMain === '[object Object]' || currenMain === undefined){
        currenMain = undefined;
    }else{
        currenMain = JSON.parse(currenMain)
    }

    const general = useGenerals();
    const [ main, setMain ] = useState(currenMain);
    const fetchMain = () => {
        let url = general.domainBackEnd+'/api/home' ;
        fetch(url)
        .then(res => res.json())
        .then( response => {
            localStorage.setItem('main',JSON.stringify(response));
            setMain(response);
        })
          .catch(function (error) {
            // handle error
            console.log(error);
          })
    }

    if(!main ){
        fetchMain();
    }

    return main;
}
